//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "HSS_score_of_knee",
  data() {
    return {
      form: {
        pain: "",
        function: "",
        active:"",
        musclePower:"",
        flexionDeformity:"",
        instability:"",
      },
      form1:{
        value1:"0",
        value2:"0",
        value3:"0",
        value4:"0",
        value5:"0",
        value6:"0",
        value7:"0",
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {
          value: "30",
          name: "任何时候均无疼痛",
        },
        {
          value: "15",
          name: " 行走时/休息时无疼痛",
        },
        {
          value: "10",
          name: "行走时/休息时轻度疼痛",
        },
        {
          value: "5",
          name: "行走时/休息时中度疼痛",
        },
        {
          value: "0",
          name: "行走时/休息时严重疼痛",
        },
      ],
      dataList2: [
        {
          value: "22",
          name: "行走站立无限制",
        },
        {
          value: "10",
          name: " 行走2500~5000米和站立半小时以上",
        },
        {
          value: "8",
          name: "行走500~2500米和站立可达到半小时",
        },
        {
          value: "5",
          name: "屋内行走，无需支具/能上楼梯",
        },
        {
          value: "4",
          name: "行走少于500米",
        },
        {
          value: "2",
          name: "屋内行走，需要支具/能上楼梯，但需支具",
        },
        {
          value: "0",
          name: "不能行走",
        }
      ],
      dataList3: [
        {
          value: "10",
          name: "优：股四头肌能完全对抗阻力",
        },
        {
          value: "8",
          name: " 良：股四头肌部分对抗阻力",
        },
        {
          value: "4",
          name: "中：能带动关节活动",
        },
        {
          value: "0",
          name: "差：不能带动关节活动",
        }
        
      ],
      dataList4: [
        {
          value: "10",
          name: "无畸形",
        },
        {
          value: "8",
          name: " 5°",
        },
        {
          value: "5",
          name: "5°~10°",
        },
        {
          value: "0",
          name: "＞10°",
        }
      ],
      dataList5: [
        {
          value: "10",
          name: "正常",
        },
        {
          value: "8",
          name: " 轻度不稳：0~5°",
        },
        {
          value: "5",
          name: "中度不稳：6°~15°",
        },
        {
          value: "0",
          name: "重度不稳：16°以上",
        }
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let form1 = JSON.parse(JSON.stringify(self.form1));
      let flag = true;
      let result = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            if (form[key] == "---") {
              flag = false;
            } else {
              form[key] = Number(form[key]);
            }
          }
        }
        if(form[key] && form[key]!='active') {
          result += Number(form[key])
        }else {
          result +=Math.floor(Number(form[key]) / 8)
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "--";
      } else {
        let reduce = form1.value1 * -1 + 
        form1.value2 * -2 + 
        form1.value3 * -3 + 
        form1.value4 * -2 + 
        form1.value5 * -3 + 
        form1.value6 * -5 + 
        form1.value7 * -1

        self.hasScore = true;
        return String(result + reduce);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Orthopaedics/HSS_score_of_knee.vue